import React from 'react';

import { Box, Popover, usePropsResolution } from 'native-base';
import type { IPopoverContentProps } from './Popover.types';

const PopoverContent: React.FunctionComponent<IPopoverContentProps> = ({
  title,
  body,
  hideClose,
  footer,
  icon,
}) => {
  const { _icon } = usePropsResolution('PopoverContent', {});
  return (
    <>
      {!hideClose && <Popover.CloseButton />}
      <Box flexDir="row">
        {icon && <Box {..._icon}>{icon}</Box>}
        <Box flexShrink={1}>
          {title && <Popover.Header>{title}</Popover.Header>}
          {body && <Popover.Body>{body}</Popover.Body>}
        </Box>
      </Box>
      {footer && <Popover.Footer>{footer}</Popover.Footer>}
    </>
  );
};

export default PopoverContent;
